/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  InspectionCreateIn,
  InspectionDetailOut,
  InspectionSaveIn,
  ListInspectionsParams,
  PaginatedInspectionOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listInspectionsResponse200 = {
  data: PaginatedInspectionOut
  status: 200
}

export type listInspectionsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listInspectionsResponseSuccess = (listInspectionsResponse200) & {
  headers: Headers;
};
export type listInspectionsResponseError = (listInspectionsResponse422) & {
  headers: Headers;
};

export type listInspectionsResponse = (listInspectionsResponseSuccess | listInspectionsResponseError)

export const getListInspectionsUrl = (params?: ListInspectionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inspections?${stringifiedParams}` : `/api/inspections`
}

/**
 * @summary List Inspections
 */
export const listInspections = async (params?: ListInspectionsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listInspectionsResponse> => {

  return apiFetch<listInspectionsResponse>(getListInspectionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInspectionsQueryKey = (params?: ListInspectionsParams,) => {
    return [
    `/api/inspections`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInspectionsQueryOptions = <TData = Awaited<ReturnType<typeof listInspections>>, TError = HTTPValidationError>(params?: ListInspectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInspectionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInspections>>> = ({ signal }) => listInspections(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInspectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listInspections>>>
export type ListInspectionsQueryError = HTTPValidationError


export function useListInspections<TData = Awaited<ReturnType<typeof listInspections>>, TError = HTTPValidationError>(
 params: undefined |  ListInspectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspections>>,
          TError,
          Awaited<ReturnType<typeof listInspections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspections<TData = Awaited<ReturnType<typeof listInspections>>, TError = HTTPValidationError>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInspections>>,
          TError,
          Awaited<ReturnType<typeof listInspections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInspections<TData = Awaited<ReturnType<typeof listInspections>>, TError = HTTPValidationError>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Inspections
 */

export function useListInspections<TData = Awaited<ReturnType<typeof listInspections>>, TError = HTTPValidationError>(
 params?: ListInspectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInspections>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInspectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createInspectionResponse201 = {
  data: InspectionDetailOut
  status: 201
}

export type createInspectionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createInspectionResponseSuccess = (createInspectionResponse201) & {
  headers: Headers;
};
export type createInspectionResponseError = (createInspectionResponse422) & {
  headers: Headers;
};

export type createInspectionResponse = (createInspectionResponseSuccess | createInspectionResponseError)

export const getCreateInspectionUrl = () => {




  return `/api/inspections`
}

/**
 * @summary Create Inspection
 */
export const createInspection = async (inspectionCreateIn: InspectionCreateIn, options?: Parameters<typeof apiFetch>[1]): Promise<createInspectionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createInspectionResponse>(getCreateInspectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inspectionCreateIn)
  }
);}





export const getCreateInspectionMutationKey = () => ['createInspection'] as const;

export const getCreateInspectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInspection>>, TError,CreateInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInspection>>, TError,CreateInspectionMutationVariables, TContext> => {

const mutationKey = getCreateInspectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInspection>>, CreateInspectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createInspection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof createInspection>>>
    export type CreateInspectionMutationBody = InspectionCreateIn
    export type CreateInspectionMutationError = HTTPValidationError
    export type CreateInspectionMutationVariables = {data: InspectionCreateIn}

    /**
 * @summary Create Inspection
 */
export const useCreateInspection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInspection>>, TError,CreateInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInspection>>,
        TError,
        CreateInspectionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateInspectionMutationOptions(options), queryClient);
    }
    export type getInspectionResponse200 = {
  data: InspectionDetailOut
  status: 200
}

export type getInspectionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getInspectionResponseSuccess = (getInspectionResponse200) & {
  headers: Headers;
};
export type getInspectionResponseError = (getInspectionResponse422) & {
  headers: Headers;
};

export type getInspectionResponse = (getInspectionResponseSuccess | getInspectionResponseError)

export const getGetInspectionUrl = (inspectionId: number,) => {




  return `/api/inspections/${inspectionId}`
}

/**
 * @summary Get Inspection
 */
export const getInspection = async (inspectionId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getInspectionResponse> => {

  return apiFetch<getInspectionResponse>(getGetInspectionUrl(inspectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInspectionQueryKey = (inspectionId: number,) => {
    return [
    `/api/inspections/${inspectionId}`
    ] as const;
    }


export const getGetInspectionQueryOptions = <TData = Awaited<ReturnType<typeof getInspection>>, TError = HTTPValidationError>(inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInspectionQueryKey(inspectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInspection>>> = ({ signal }) => getInspection(inspectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: inspectionId !== null && inspectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInspectionQueryResult = NonNullable<Awaited<ReturnType<typeof getInspection>>>
export type GetInspectionQueryError = HTTPValidationError


export function useGetInspection<TData = Awaited<ReturnType<typeof getInspection>>, TError = HTTPValidationError>(
 inspectionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInspection>>,
          TError,
          Awaited<ReturnType<typeof getInspection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInspection<TData = Awaited<ReturnType<typeof getInspection>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInspection>>,
          TError,
          Awaited<ReturnType<typeof getInspection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInspection<TData = Awaited<ReturnType<typeof getInspection>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inspection
 */

export function useGetInspection<TData = Awaited<ReturnType<typeof getInspection>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspection>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInspectionQueryOptions(inspectionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type saveInspectionResponse200 = {
  data: InspectionDetailOut
  status: 200
}

export type saveInspectionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type saveInspectionResponseSuccess = (saveInspectionResponse200) & {
  headers: Headers;
};
export type saveInspectionResponseError = (saveInspectionResponse422) & {
  headers: Headers;
};

export type saveInspectionResponse = (saveInspectionResponseSuccess | saveInspectionResponseError)

export const getSaveInspectionUrl = (inspectionId: number,) => {




  return `/api/inspections/${inspectionId}`
}

/**
 * @summary Save Inspection
 */
export const saveInspection = async (inspectionId: number,
    inspectionSaveIn: InspectionSaveIn, options?: Parameters<typeof apiFetch>[1]): Promise<saveInspectionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<saveInspectionResponse>(getSaveInspectionUrl(inspectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inspectionSaveIn)
  }
);}





export const getSaveInspectionMutationKey = () => ['saveInspection'] as const;

export const getSaveInspectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInspection>>, TError,SaveInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveInspection>>, TError,SaveInspectionMutationVariables, TContext> => {

const mutationKey = getSaveInspectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveInspection>>, SaveInspectionMutationVariables> = (props) => {
          const {inspectionId,data} = props ?? {};

          return  saveInspection(inspectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof saveInspection>>>
    export type SaveInspectionMutationBody = InspectionSaveIn
    export type SaveInspectionMutationError = HTTPValidationError
    export type SaveInspectionMutationVariables = {inspectionId: number;data: InspectionSaveIn}

    /**
 * @summary Save Inspection
 */
export const useSaveInspection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInspection>>, TError,SaveInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveInspection>>,
        TError,
        SaveInspectionMutationVariables,
        TContext
      > => {
      return useMutation(getSaveInspectionMutationOptions(options), queryClient);
    }
    export type deleteInspectionResponse204 = {
  data: void
  status: 204
}

export type deleteInspectionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteInspectionResponseSuccess = (deleteInspectionResponse204) & {
  headers: Headers;
};
export type deleteInspectionResponseError = (deleteInspectionResponse422) & {
  headers: Headers;
};

export type deleteInspectionResponse = (deleteInspectionResponseSuccess | deleteInspectionResponseError)

export const getDeleteInspectionUrl = (inspectionId: number,) => {




  return `/api/inspections/${inspectionId}`
}

/**
 * @summary Delete Inspection
 */
export const deleteInspection = async (inspectionId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteInspectionResponse> => {

  return apiFetch<deleteInspectionResponse>(getDeleteInspectionUrl(inspectionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteInspectionMutationKey = () => ['deleteInspection'] as const;

export const getDeleteInspectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInspection>>, TError,DeleteInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInspection>>, TError,DeleteInspectionMutationVariables, TContext> => {

const mutationKey = getDeleteInspectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInspection>>, DeleteInspectionMutationVariables> = (props) => {
          const {inspectionId} = props ?? {};

          return  deleteInspection(inspectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInspection>>>

    export type DeleteInspectionMutationError = HTTPValidationError
    export type DeleteInspectionMutationVariables = {inspectionId: number}

    /**
 * @summary Delete Inspection
 */
export const useDeleteInspection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInspection>>, TError,DeleteInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInspection>>,
        TError,
        DeleteInspectionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteInspectionMutationOptions(options), queryClient);
    }
    export type completeInspectionResponse200 = {
  data: InspectionDetailOut
  status: 200
}

export type completeInspectionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type completeInspectionResponseSuccess = (completeInspectionResponse200) & {
  headers: Headers;
};
export type completeInspectionResponseError = (completeInspectionResponse422) & {
  headers: Headers;
};

export type completeInspectionResponse = (completeInspectionResponseSuccess | completeInspectionResponseError)

export const getCompleteInspectionUrl = (inspectionId: number,) => {




  return `/api/inspections/${inspectionId}/complete`
}

/**
 * @summary Complete Inspection
 */
export const completeInspection = async (inspectionId: number, options?: Parameters<typeof apiFetch>[1]): Promise<completeInspectionResponse> => {

  return apiFetch<completeInspectionResponse>(getCompleteInspectionUrl(inspectionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompleteInspectionMutationKey = () => ['completeInspection'] as const;

export const getCompleteInspectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeInspection>>, TError,CompleteInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeInspection>>, TError,CompleteInspectionMutationVariables, TContext> => {

const mutationKey = getCompleteInspectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeInspection>>, CompleteInspectionMutationVariables> = (props) => {
          const {inspectionId} = props ?? {};

          return  completeInspection(inspectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof completeInspection>>>

    export type CompleteInspectionMutationError = HTTPValidationError
    export type CompleteInspectionMutationVariables = {inspectionId: number}

    /**
 * @summary Complete Inspection
 */
export const useCompleteInspection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeInspection>>, TError,CompleteInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeInspection>>,
        TError,
        CompleteInspectionMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteInspectionMutationOptions(options), queryClient);
    }
    export type reopenInspectionResponse200 = {
  data: InspectionDetailOut
  status: 200
}

export type reopenInspectionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reopenInspectionResponseSuccess = (reopenInspectionResponse200) & {
  headers: Headers;
};
export type reopenInspectionResponseError = (reopenInspectionResponse422) & {
  headers: Headers;
};

export type reopenInspectionResponse = (reopenInspectionResponseSuccess | reopenInspectionResponseError)

export const getReopenInspectionUrl = (inspectionId: number,) => {




  return `/api/inspections/${inspectionId}/reopen`
}

/**
 * @summary Reopen Inspection
 */
export const reopenInspection = async (inspectionId: number, options?: Parameters<typeof apiFetch>[1]): Promise<reopenInspectionResponse> => {

  return apiFetch<reopenInspectionResponse>(getReopenInspectionUrl(inspectionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReopenInspectionMutationKey = () => ['reopenInspection'] as const;

export const getReopenInspectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenInspection>>, TError,ReopenInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenInspection>>, TError,ReopenInspectionMutationVariables, TContext> => {

const mutationKey = getReopenInspectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenInspection>>, ReopenInspectionMutationVariables> = (props) => {
          const {inspectionId} = props ?? {};

          return  reopenInspection(inspectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof reopenInspection>>>

    export type ReopenInspectionMutationError = HTTPValidationError
    export type ReopenInspectionMutationVariables = {inspectionId: number}

    /**
 * @summary Reopen Inspection
 */
export const useReopenInspection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenInspection>>, TError,ReopenInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenInspection>>,
        TError,
        ReopenInspectionMutationVariables,
        TContext
      > => {
      return useMutation(getReopenInspectionMutationOptions(options), queryClient);
    }
    export type getInspectionPdfResponse200 = {
  data: Blob
  status: 200
}

export type getInspectionPdfResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getInspectionPdfResponseSuccess = (getInspectionPdfResponse200) & {
  headers: Headers;
};
export type getInspectionPdfResponseError = (getInspectionPdfResponse422) & {
  headers: Headers;
};

export type getInspectionPdfResponse = (getInspectionPdfResponseSuccess | getInspectionPdfResponseError)

export const getGetInspectionPdfUrl = (inspectionId: number,) => {




  return `/api/inspections/${inspectionId}/pdf`
}

/**
 * @summary Get Inspection Pdf
 */
export const getInspectionPdf = async (inspectionId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getInspectionPdfResponse> => {

  return apiFetch<getInspectionPdfResponse>(getGetInspectionPdfUrl(inspectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInspectionPdfQueryKey = (inspectionId: number,) => {
    return [
    `/api/inspections/${inspectionId}/pdf`
    ] as const;
    }


export const getGetInspectionPdfQueryOptions = <TData = Awaited<ReturnType<typeof getInspectionPdf>>, TError = HTTPValidationError>(inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInspectionPdfQueryKey(inspectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInspectionPdf>>> = ({ signal }) => getInspectionPdf(inspectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: inspectionId !== null && inspectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInspectionPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInspectionPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getInspectionPdf>>>
export type GetInspectionPdfQueryError = HTTPValidationError


export function useGetInspectionPdf<TData = Awaited<ReturnType<typeof getInspectionPdf>>, TError = HTTPValidationError>(
 inspectionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInspectionPdf>>,
          TError,
          Awaited<ReturnType<typeof getInspectionPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInspectionPdf<TData = Awaited<ReturnType<typeof getInspectionPdf>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInspectionPdf>>,
          TError,
          Awaited<ReturnType<typeof getInspectionPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInspectionPdf<TData = Awaited<ReturnType<typeof getInspectionPdf>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inspection Pdf
 */

export function useGetInspectionPdf<TData = Awaited<ReturnType<typeof getInspectionPdf>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInspectionPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInspectionPdfQueryOptions(inspectionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






